import React from 'react';

const GridEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
}) => {
  // Detect if panel is open by checking if nodes are in vertical layout
  // When panel is open, nodes are positioned vertically with similar X coordinates
  const isPanelOpen = Math.abs(sourceX - targetX) < 50; // Threshold for detecting vertical layout

  // Calculate the path with right angles and rounded corners
  const createGridPath = () => {
    const cornerRadius = 8; // Adjust this for more/less rounded corners

    if (isPanelOpen) {
      // Panel is open: go straight down (top to bottom)
      return `M ${sourceX} ${sourceY} L ${targetX} ${targetY}`;
    } else {
      // Panel is closed: go down first, then right (bottom to left pattern)
      const cornerX = sourceX;
      const cornerY = targetY;

      // Create path: down then right with rounded corner
      const path = `M ${sourceX} ${sourceY} 
                    L ${cornerX} ${cornerY - cornerRadius} 
                    Q ${cornerX} ${cornerY} ${cornerX + cornerRadius} ${cornerY}
                    L ${targetX} ${targetY}`;

      return path;
    }
  };

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={createGridPath()}
        markerEnd={markerEnd}
        fill="none"
      />
    </>
  );
};

export default GridEdge;

